var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedicalDuotone = function SvgMedicalDuotone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 54,
    viewBox: "0 0 41 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prescription-bottle-medical-duotone",
    clipPath: "url(#clip0_1150_2193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.1302 28.6667H24.1302V23.5729C24.1302 22.6562 23.3803 21.9063 22.4635 21.9063H19.1302C18.2134 21.9063 17.4635 22.6562 17.4635 23.5729V28.6667H12.4635C11.5469 28.6667 10.7969 29.4167 10.7969 30.3333V33.6667C10.7969 34.5832 11.5468 35.3333 12.4635 35.3333H17.4635V40.3333C17.4635 41.2499 18.2134 42 19.1302 42H22.4635C23.3803 42 24.1302 41.2499 24.1302 40.3333V35.3333H29.1302C30.047 35.3333 30.7969 34.5832 30.7969 33.6667V30.3333C30.7969 29.4167 30.0469 28.6667 29.1302 28.6667ZM38.2969 0.333336H3.29688C1.91667 0.333336 0.796875 1.45313 0.796875 2.83334V7.83334C0.796875 9.21354 1.91667 10.3333 3.29688 10.3333H38.2969C39.6823 10.3333 40.7969 9.21354 40.7969 7.83334V2.83334C40.7969 1.45313 39.6823 0.333336 38.2969 0.333336Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M4.12891 47C4.12891 50.6667 7.12891 53.6667 10.7956 53.6667H30.7956C34.4622 53.6667 37.4622 50.6667 37.4622 47V10.3333H4.12891V47ZM10.7956 30.3333C10.7956 29.4166 11.5455 28.6667 12.4622 28.6667H17.4622V23.5729C17.4622 22.6561 18.2121 21.9063 19.1289 21.9063H22.4622C23.379 21.9063 24.1289 22.6561 24.1289 23.5729V28.6667H29.1289C30.0456 28.6667 30.7956 29.4167 30.7956 30.3333V33.6667C30.7956 34.5832 30.0457 35.3333 29.1289 35.3333H24.1289V40.3333C24.1289 41.2499 23.379 42 22.4622 42H19.1289C18.2122 42 17.4622 41.25 17.4622 40.3333V35.3333H12.4622C11.5456 35.3333 10.7956 34.5833 10.7956 33.6667V30.3333Z",
    fill: "#DADADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1150_2193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 53.3333,
    fill: "white",
    transform: "translate(0.796875 0.333336)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedicalDuotone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medical-duotone.2288a8d3.svg";
export { ForwardRef as ReactComponent };